import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/productSalesSagas";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();

  const dateFormat = useDateFormat();

  const {
    selectedRequestDates: { startDate, endDate },
    currentUser: { calendarEndDate, calendarStartDate }
  } = useSelector((state) => state.productSales);

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      isRangePicker
      showDefaultInputIcon={false}
      minDate={calendarStartDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate: startDate, endDate: endDate }))
      }
    />
  );
};

export default DatePicker;
